import { Routes } from '@angular/router';
import { authGuard } from './auth/guards';
import { publicGuard } from './auth/guards/public.guard';
import { landingGuard } from './auth/guards/landing.guard';
import { authRedirectResolver } from './shared/Utils/resolvers/auth-redirect.resolver';
import { mainPagesRoutes } from './main/pages/main-pages.routes';
import { adminPagesRoutes } from './admin/pages/admin-pages.routes';
import { titleResolver } from './shared/Utils/resolvers/title.resolver';
import { publicRoutes, termsRoutes, landingRoutes } from './public/public.routes';

export const routes: Routes = [
  {
    path: 'inicio',
    canActivate: [landingGuard],
    children: landingRoutes,
  },
  {
    path: 'evento-publico/:id',
    canActivate: [publicGuard],
    resolve: {
      titleResolver,
    },
    data: {
      titleTranslationKey: 'publicEvent.title',
    },
    loadComponent: async () =>
      (await import('./public/layout/public-layout.component'))
        .PublicLayoutComponent,
    children: publicRoutes,
  },
  {
    path: 'terminos-condiciones',
    canActivate: [publicGuard],
    resolve: {
      titleResolver,
    },
    data: {
      titleTranslationKey: 'terms.title',
    },
    loadComponent: async () =>
      (await import('./public/layout/public-layout.component'))
        .PublicLayoutComponent,
    children: termsRoutes,
  },
  {
    path: '',
    canActivate: [authGuard],
    resolve: {
      redirectTo: authRedirectResolver,
    },
    runGuardsAndResolvers: 'always',
    loadComponent: async () =>
      (await import('./main/main-layout/main-layout.component'))
        .MainLayoutComponent,
    children: mainPagesRoutes,
  },
  {
    path: 'admin',
    resolve: {
      titleResolver,
    },
    canActivate: [authGuard],
    data: {
      roles: ['AppPermissions.TECHNICALOFFICE'],
      titleTranslationKey: 'routes.admin.admin',
    },
    loadComponent: async () =>
      (await import('./admin/admin-layout/admin-layout.component'))
        .AdminLayoutComponent,
    children: adminPagesRoutes,
  },
  {
    path: 'not-found',
    data: {
      titleTranslationKey: 'routes.not-found',
    },
    resolve: {
      titleResolver,
    },
    loadComponent: async () =>
      (await import('./error404/error404.component')).Error404Component,
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
